import React from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({
  filters,
  onFilterChange,
  onClearFilters,
  focusAreas,
  statusOptions,
  sortOptions
}) => {
  const amountRanges = [
    { value: '', label: 'Any Amount' },
    { value: '10000', label: '$10K+' },
    { value: '25000', label: '$25K+' },
    { value: '50000', label: '$50K+' },
    { value: '100000', label: '$100K+' },
    { value: '250000', label: '$250K+' },
    { value: '500000', label: '$500K+' },
    { value: '1000000', label: '$1M+' }
  ];

  const focusAreaOptions = focusAreas?.map(area => ({
    value: area,
    label: area
  }));

  const hasActiveFilters = Object.values(filters)?.some(value => value && value !== 'deadline');

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold">Filters</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
          >
            <Icon name="X" size={14} className="mr-1" />
            Clear
          </Button>
        )}
      </div>
      {/* Status Filter */}
      <div>
        <label className="block text-sm font-medium mb-2">Status</label>
        <Select
          options={[{ value: '', label: 'All Statuses' }, ...statusOptions]}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          placeholder="Select status"
        />
      </div>
      {/* Focus Area Filter */}
      <div>
        <label className="block text-sm font-medium mb-2">Focus Area</label>
        <Select
          options={[{ value: '', label: 'All Focus Areas' }, ...focusAreaOptions]}
          value={filters?.focus_area}
          onChange={(value) => onFilterChange('focus_area', value)}
          placeholder="Select focus area"
        />
      </div>
      {/* Amount Filter */}
      <div>
        <label className="block text-sm font-medium mb-2">Minimum Amount</label>
        <Select
          options={amountRanges}
          value={filters?.amount_min}
          onChange={(value) => onFilterChange('amount_min', value)}
          placeholder="Select amount"
        />
      </div>
      {/* Custom Amount Input */}
      <div>
        <label className="block text-sm font-medium mb-2">Custom Minimum ($)</label>
        <Input
          type="number"
          placeholder="Enter amount"
          value={filters?.amount_min}
          onChange={(e) => onFilterChange('amount_min', e?.target?.value)}
          min="0"
          step="1000"
        />
      </div>
      {/* Sort Options */}
      <div>
        <label className="block text-sm font-medium mb-2">Sort By</label>
        <Select
          options={sortOptions}
          value={filters?.sort}
          onChange={(value) => onFilterChange('sort', value)}
          placeholder="Select sorting"
        />
      </div>
      {/* Quick Filters */}
      <div>
        <label className="block text-sm font-medium mb-2">Quick Filters</label>
        <div className="space-y-2">
          <Button
            variant={filters?.status === 'open' ? 'default' : 'outline'}
            size="sm"
            onClick={() => onFilterChange('status', filters?.status === 'open' ? '' : 'open')}
            className="w-full justify-start"
          >
            <Icon name="CircleDot" size={14} className="mr-2" />
            Open Grants
          </Button>
          
          <Button
            variant={filters?.status === 'closing_soon' ? 'default' : 'outline'}
            size="sm"
            onClick={() => onFilterChange('status', filters?.status === 'closing_soon' ? '' : 'closing_soon')}
            className="w-full justify-start"
          >
            <Icon name="Clock" size={14} className="mr-2" />
            Closing Soon
          </Button>
          
          <Button
            variant={filters?.amount_min === '100000' ? 'default' : 'outline'}
            size="sm"
            onClick={() => onFilterChange('amount_min', filters?.amount_min === '100000' ? '' : '100000')}
            className="w-full justify-start"
          >
            <Icon name="DollarSign" size={14} className="mr-2" />
            $100K+ Grants
          </Button>
        </div>
      </div>
      {/* Filter Summary */}
      {hasActiveFilters && (
        <div className="pt-4 border-t border-border">
          <p className="text-sm font-medium mb-2">Active Filters:</p>
          <div className="space-y-1">
            {filters?.status && (
              <div className="flex items-center justify-between text-xs">
                <span>Status:</span>
                <span className="font-medium capitalize">{filters?.status?.replace('_', ' ')}</span>
              </div>
            )}
            {filters?.focus_area && (
              <div className="flex items-center justify-between text-xs">
                <span>Focus:</span>
                <span className="font-medium">{filters?.focus_area}</span>
              </div>
            )}
            {filters?.amount_min && (
              <div className="flex items-center justify-between text-xs">
                <span>Min Amount:</span>
                <span className="font-medium">${parseInt(filters?.amount_min)?.toLocaleString()}+</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;